import React from 'react';

/**
 * @author 이현우
 * @returns
 */
const UntactStep1 = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5625 13.4062H10.4454C10.5258 13.409 10.6064 13.4103 10.6872 13.4104C10.7695 13.4104 10.8517 13.409 10.9338 13.4062H14.8125C16.3371 13.4062 17.6792 13.824 18.6104 14.4448C19.5505 15.0715 19.9688 15.8204 19.9688 16.5V19.5938H1.40625V16.5C1.40625 15.8204 1.82455 15.0715 2.76461 14.4448C3.69581 13.824 5.0379 13.4062 6.5625 13.4062ZM10.8959 11.3438H10.6875H10.4832C9.18951 11.292 7.95959 10.7552 7.04087 9.83582C6.07382 8.86813 5.53079 7.55591 5.53125 6.18784C5.53148 5.51044 5.66512 4.83972 5.92456 4.21397C6.184 3.58823 6.56415 3.0197 7.0433 2.54087C7.52245 2.06204 8.09123 1.68227 8.71715 1.42325C9.34307 1.16422 10.0139 1.03102 10.6913 1.03125C11.3687 1.03148 12.0394 1.16512 12.6652 1.42456C13.2909 1.684 13.8594 2.06415 14.3383 2.5433C14.8171 3.02245 15.1969 3.59123 15.4559 4.21715C15.7149 4.84307 15.8481 5.51388 15.8479 6.19128C15.8474 7.55935 15.3035 8.87121 14.3358 9.83826C13.4173 10.7562 12.1884 11.292 10.8959 11.3438Z"
        stroke="white"
        strokeWidth="2.0625"
      />
    </svg>
  );
};

export default UntactStep1;
